// Only known staff screens may be restored after sign-in or a push tap.
export function staffDestination(value, fallback = '/staff') {
  if (typeof value !== 'string' || !value.startsWith('/staff/') || /[\\\s]/.test(value)) return fallback;
  try {
    const url = new URL(value, 'https://staff.poutaesthetics.co.uk');
    if (url.origin !== 'https://staff.poutaesthetics.co.uk') return fallback;
    return /^\/staff\/(?:notifications\/[a-f0-9]{64}|appointments(?:\/\d+(?:\/checkout)?)?|forms\/review|settings\/app)$/.test(url.pathname)
      ? url.pathname + url.search : fallback;
  } catch { return fallback; }
}
